import { normalize, denormalize } from 'normalizr';
import normalizrSchemas from '../normalizrSchema'
import { getApi, cache } from '../api';

const modelNameData = {
  'Partner': { entityType: 'partners', listSchema: 'partnerListSchema' },
  'Translator': { entityType: 'translators', listSchema: 'translatorListSchema' },
  'Contact': { entityType: 'contacts', listSchema: 'contactListSchema' },
  'ContactDetail': { entityType: 'contactDetails', listSchema: 'contactDetailListSchema' },
  'Event': { entityType: 'events', listSchema: 'eventListSchema' },
  'ChatMessage': { entityType: 'chatMessages', listSchema: 'chatMessageListSchema' },
  'Customer': { entityType: 'customers', listSchema: 'customerListSchema' },
  'Region': { entityType: 'regions', listSchema: 'regionListSchema' },
  'Standard': { entityType: 'standards', listSchema: 'standardListSchema' },
  'StandardGroup': { entityType: 'standardGroups', listSchema: 'standardGroupListSchema' },
};

let REMOVE_ENTITY = ({ state, commit }, { url, entityType, id }) => {
  return new Promise((resolve, reject) => {
    getApi()
      .then(api => {
        api.delete(url + '/' + id)
          .then(() => {
            commit('REMOVE_ENTITY', { entityType, id });
            resolve();
          })
          .catch(err => {
            reject(err);
          })
      })
  });
};

let SAVE_ENTITY = ({ state, commit }, { url, entityType, schema, listSchema, entityId, entity, isNew = false }) => {
  console.log('SAVE_ENTITY', url, entityType, schema, entityId, entity, isNew);
  return new Promise((resolve, reject) => {
    getApi()
      .then(api => {
        let f = isNew ? api.post : api.patch;
        let u = isNew ? url : url + '/' + entityId;

        console.log('denormalize', entity, normalizrSchemas[schema], state.editableEntities);
        if (schema === 'countrySchema' || schema === 'regionSchema' || schema === 'standardGroupSchema') {
          schema += 'Fix';
        }
        console.log('denormalize', entity, normalizrSchemas[schema], state.editableEntities)
        const params = denormalize(entity, normalizrSchemas[schema], state.editableEntities);
        for (let key of Object.keys(params)) {
          if (params[key] === null || params[key] === undefined) {
            params[key] = "";
          }
        }
        if(params.sar && params.sar.type === "BOOLEAN") {
          params.sar = params.sar.value;
        }

        f(u, params)
          .then(({ data }) => {
            let results = [data.result];
            // console.log('results', results);
            const normalizedEntity = normalize(results, normalizrSchemas[listSchema]);
            // console.log('normalizedEntity', normalizedEntity);
            commit('UPDATE_ENTITIES', { entities: normalizedEntity.entities, list: normalizedEntity.result, listEntitiesType: entityType, replace: false });
            resolve();
          })
          .catch(err => {
            reject(err);
          })
      });
  });
};

export default {

  CLEAR_CACHE: () => {
    return new Promise((resolve) => {
      // console.log('CLEAR_CACHE')
      cache.reset();
      setTimeout(() => {
        resolve();
      }, 100)
    });
  },

  API_GET: ({ commit, dispatch }, { url, entityType, schema, params = {}, replace = false }) => {
    return new Promise((resolve, reject) => {
      commit('SET_FETCHING', true);
      getApi()
        .then(api => {
          api.get(url, { params })
            .then(({ data }) => {
              let results, totalResults;
              if (data.results) {
                results = data.results;
                totalResults = data.totalResults;
              } else if (data.result) {
                results = [data.result];
                totalResults = 1;
              } else {
                throw new Error('Request failed');
              }
              console.log(schema, results);
              const normalizedEntity = normalize(results, normalizrSchemas[schema]);
              console.log(schema, normalizedEntity);
              commit('UPDATE_ENTITIES', { entities: normalizedEntity.entities, list: normalizedEntity.result, listEntitiesType: entityType, replace });
              resolve({ totalResults, list: normalizedEntity.result });
            })
            .catch(err => {
              dispatch('SHOW_SNACKBAR', {
                text: err.message,
                color: 'error'
              });
              reject(err);
            })
            .finally(() => {
              commit('SET_FETCHING', false);
            });
        });
    });
  },

  REMOVE_ENTITY,

  SAVE_ENTITY,

  "SOCKET_resource_created": ({ state, commit }, payload) => {
    // console.log(payload);
    if (modelNameData[payload.modelName]) {
      let { entityType, listSchema } = modelNameData[payload.modelName];
      if (entityType) {
        let results = [payload.resource];
        // console.log('results', results);
        // console.log('listSchema', listSchema);
        const normalizedEntity = normalize(results, normalizrSchemas[listSchema]);
        // console.log('normalizedEntity', normalizedEntity);
        commit('UPDATE_ENTITIES', { entities: normalizedEntity.entities, list: normalizedEntity.result, listEntitiesType: entityType, replace: false });
      }
    }
  },

  "SOCKET_resource_updated": ({ state, commit }, payload) => {
    console.log(payload)
    if (modelNameData[payload.modelName]) {
      let { entityType, listSchema } = modelNameData[payload.modelName];
      if (entityType) {
        let results = [payload.resource];
        console.log('results', results);
        // console.log('listSchema', listSchema);
        const normalizedEntity = normalize(results, normalizrSchemas[listSchema]);
        console.log('normalizedEntity', normalizedEntity);
        commit('UPDATE_ENTITIES', { entities: normalizedEntity.entities, list: normalizedEntity.result, listEntitiesType: entityType, replace: false });
      }
    }
  },

  "SOCKET_resource_removed": ({ state, commit }, payload) => {
    if (modelNameData[payload.modelName]) {
      let { entityType } = modelNameData[payload.modelName];
      if (entityType) {
        commit('REMOVE_ENTITY', { entityType, id: payload.resource._id });
      }
    }
  },

  TOGGLE_NIGHT_MODE: ({ commit }, { payload }) => {
    commit('TOGGLE_NIGHT_MODE', payload);
  },
  TOGGLE_MAIN_MENU: ({ commit }, { isActive }) => {
    commit('TOGGLE_MAIN_MENU', isActive);
  },
  SET_MAIN_MENU_MINI_VARIANT: ({ commit }, { isActive }) => {
    commit('SET_MAIN_MENU_MINI_VARIANT', isActive);
  },
  SET_SHOULD_SHOW_MAIN_MENU_AUTOMATICALLY: ({ commit }, { payload }) => {
    commit('SET_SHOULD_SHOW_MAIN_MENU_AUTOMATICALLY', payload);
  },
  SHOW_SNACKBAR: ({ commit }, { text, color }) => {
    commit('SET_SNACKBAR_DATA', { text, color });
    commit('SET_SNACKBAR', true);
  },
  HIDE_SNACKBAR: ({ commit }) => {
    commit('SET_SNACKBAR', false);
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js